import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {AclService} from '../services/acl.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable()
export class AclGuard implements CanActivate {

    constructor(
        protected aclService: AclService,
        private router: Router
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const {permissionArea} = route.data;
        if (
            (Array.isArray(permissionArea) && permissionArea.some(item => this.aclService.checkAcl(item)))
            || (!Array.isArray(permissionArea) && this.aclService.checkAcl(permissionArea))
        ) {
            return true;
        } else {
            this.router.navigateByUrl('/forbidden');
            return false;
        }
    }
}
